import React from 'react';
import { Navigate } from 'react-router-dom'; // Убрали Outlet и useLocation, они здесь не нужны
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './utils/context/useAuthContext';

interface PublicRouteProps {
  children?: React.ReactNode; // children здесь будет содержать <Auth/> layout
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  // Добавили лог с правильным префиксом
  console.log(
    '[PublicRoute] Rendering. isLoading:',
    isLoading,
    'isAuthenticated:',
    isAuthenticated,
  );

  // 1. Показываем индикатор, пока идет проверка статуса
  if (isLoading) {
    console.log('[PublicRoute] State: Loading...');
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // 2. Если проверка завершена и пользователь УЖЕ аутентифицирован
  if (isAuthenticated) {
    console.log(
      '[PublicRoute] State: Authenticated. Redirecting to dashboard.',
    );
    // Перенаправляем на главный экран приложения
    return <Navigate to="/dashboard" replace />;
  }

  // 3. Если проверка завершена и пользователь НЕ аутентифицирован
  console.log('[PublicRoute] State: Not Authenticated. Rendering children.');
  // Показываем дочерний компонент (в вашем случае, <Auth/> layout)
  return <>{children}</>;
};

export default PublicRoute;
